import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mdtohtml'
})
export class MdtohtmlPipe implements PipeTransform {

  transform(markdown: any): string {
    if(!markdown) return "";

    const html = markdown.replace(/^### (.*$)/gim, '<h3>$1</h3>') // h3 tag
      .replace(/^## (.*$)/gim, '<h2>$1</h2>') // h2 tag
      .replace(/^# (.*$)/gim, '<h1>$1</h1>') // h1 tag
      .replace(/\*\*(.*)\*\*/gim, '<b>$1</b>') // bold text
      .replace(/\*(.*)\*/gim, '<i>$1</i>') // italic text
      .replace(/\_(.*)\_/gim, '<i>$1</i>') // italic text
      .replace(/\r\n|\r|\n/gim, '<br>') // linebreaks
      .replace(/\[([^\[]+)\](\(([^)]*))\)/gim, '<a href="$3">$1</a>'); // anchor tags

    return html;
  }

}
